class ProductTabs extends HTMLElement {
  constructor () {
    super()

    this.triggerEls = this.querySelectorAll('[data-el="product-tabs.trigger"]')

    this.panelEls = this.querySelectorAll('[data-el="product-tabs.panel"]')

    this.triggerEls.forEach(triggerEl => {
      triggerEl.addEventListener('click', this.handleTrigger.bind(this))
    })
  }

  handleTrigger = event => {
    const optionValue = event.target.dataset.value

    this.triggerEls.forEach(triggerEl => {
      if (triggerEl.dataset.value === optionValue) {
        triggerEl.setAttribute('aria-selected', true)
      } else {
        triggerEl.setAttribute('aria-selected', false)
      }
    })

    this.panelEls.forEach(panelEl => {
      if (panelEl.dataset.value === optionValue) {
        panelEl.hidden = false
      } else {
        panelEl.hidden = true
      }
    })
  }
}

customElements.define('product-tabs', ProductTabs)
